module.exports = __webpack_public_path__ + "static/media/logo-small.9dd0d8dd.png";